<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="card-global">
        <el-row style="margin-bottom: 20px; width: 100%">{{ selectSj ? '选择试卷' : '创建试卷' }}</el-row>
        <el-row>
          <el-form ref="form" :model="sjk" :rules="rules" label-position="right" label-width="110px" v-if="!selectSj">
            <el-form-item label="试卷名称" class="formItem" prop="sjmc">
              <el-input v-model="sjk.sjmc" style="width:400px" placeholder="请输入试卷名称" autocomplete="off"></el-input>
              <el-button type="success" style="margin-left: 20px" v-if="ksid_init" @click="toSelectSj">选择试卷</el-button>
            </el-form-item>
            <el-form-item label="试卷分类" class="formItem" prop="flbh">
                <!-- <el-select ref="flbh" v-model="sjk.flbh" style="width:400px" placeholder="请选择试卷分类" @focus="reloadSjfl()">
                  <el-option :value="flObj.flbh" :label="flObj.flmc" style="height: auto">
                    <classifyTree id="sjfltree" ref="sjflTree" :value.sync="flObj"
                     type="examPaper" @click="$refs['flbh'].blur()"></classifyTree>
                  </el-option>
                </el-select> -->
                <classify :value.sync="sjk.flbh" type="examPaper" style="width:400px" :multiple="false"></classify>
                &nbsp;
                <el-button type="primary" @click="showFlDialog()">编辑试卷分类</el-button>
            </el-form-item>
            <el-dialog title="编辑分类" :visible.sync="showSjflDialog" width="40%" center>
              <classifyTreeEdit ref="sjflTreeEdit" type="examPaper" :visible.sync="showSjflDialog"></classifyTreeEdit>
            </el-dialog>
            <el-form-item label="组卷方式" class="formItem" prop="zjfs">
              <el-radio-group v-model="sjk.zjfs" @change="changeZjfs">
                <el-radio-button label="1">选题组卷</el-radio-button>
                <el-radio-button label="2">抽题组卷</el-radio-button>
                <el-radio-button label="3">随机组卷</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item style="text-align: right; width: 500px">
              <el-button type="primary" style="width: 180px" @click="submitForm">下一步</el-button>
            </el-form-item>
          </el-form>
          <el-form :inline="true" :model="form" label-position="right" label-width="110px" v-if="ksid_init && selectSj">
            <el-row>
              <el-col :span=18 style="text-align:left">
                <el-form-item label="试卷分类">
                  <classify :value.sync="form.flbhList" type="examPaper" :multiple="true"></classify>
                  <el-button type="primary" @click="showDialog = true">筛选</el-button>
                </el-form-item>
                <el-dialog title="选择试卷分类" :visible.sync="showDialog" :append-to-body="true" width="30%" center>
                  <classifyTree :value.sync="form.flbhList" type="examPaper" :visible.sync="showDialog"></classifyTree>
                </el-dialog>
                <el-form-item label="">
                  <el-input v-model="form.sjmc" style="width:400px" placeholder="请输入试卷名称" @keyup.enter.native="query()"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="query()">查询</el-button>
                </el-form-item>
              </el-col>
              <el-col :span=6 style="text-align: right">
                <el-form-item label="">
                  <el-button type="success" @click="toEdit">选择并编辑</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row style="padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)" v-if="ksid_init && selectSj">
            <el-table :data="tableData" style="width: 100%" :border="true" height="400" highlight-current-row @current-change="handleRowSelChange">
              <el-table-column label="试卷名称" width="300" prop="sjmc"/>
              <el-table-column label="试卷类型" width="120" prop="flmc"/>
              <el-table-column label="总分" width="80" prop="sjzf" align="right"/>
              <el-table-column label="组卷方式" width="155" prop="zjfsms" align="center"/>
              <el-table-column label="创建人" width="120" prop="cjrmc"/>
              <el-table-column label="结束时间" width="155"  prop="cjsj"/>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
              </el-pagination>
          </el-row>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import classify from '@/components/select/classify'
import classifyTree from '@/components/tree/classifyTree'
import classifyTreeEdit from '@/components/tree/classifyTreeEdit'
import { getList, info } from '@/api/examPaper'
export default {
  data () {
    return {
      ksid_init: null,

      flObj: {},
      selectSj: false,

      showDialog: false,
      showSjflDialog: false, // 显示考试分类
      sjid: null,
      form: {
        sjmc: '',
        flbhList: []
      },
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: [],

      oldZjfs: null,
      sjk: {
        sjmc: '',
        flbh: null,
        zjfs: null
      },
      rules: {
        sjmc: [
          { required: true, message: '请输入试卷名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        flbh: [
          { required: true, message: '请选择分类编号', trigger: 'change' }
        ],
        zjfs: [
          { required: true, message: '请选择组卷方式', trigger: 'change' }
        ]
      }
    }
  },
  components: {
    myHeader,
    classify,
    classifyTree,
    classifyTreeEdit
  },
  watch: {
    flObj (val) {
      this.sjk.flbh = val.flbh
    }
  },
  methods: {
    toSelectSj () {
      this.selectSj = true
      this.query()
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = { pageNo: this.currentPage, pageSize: this.pageSize }
      params.sjmc = this.form.sjmc
      params.notUsed = '1' // 试卷未被使用
      params.flbhs = this.form.flbhList.join(',')
      getList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    },
    handleRowSelChange (row) {
      this.sjid = row.sjid
    },
    toEdit () {
      if (this.sjid) {
        const query = { sjid: this.sjid, ksid: this.ksid_init, autoSave: true }
        this.$router.push({
          path: '/examPaper/edit',
          query: query
        })
      } else {
        this.$message.warning('请选择试卷')
        return false
      }
    },
    changeZjfs (value) {
      if (this.sjk.sjid) {
        this.$confirm('改变组卷方式需要重新选择试题，确定要修改吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {}).catch(() => {
          this.sjk.zjfs = this.oldZjfs
        })
      }
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const query = this.sjk
          if (this.ksid_init) {
            query.ksid = this.ksid_init
          }
          if (this.$route.path.endsWith('/exam/add')) {
            this.$router.push({
              path: '/exam/edit',
              query: query
            })
          } else {
            this.$router.push({
              path: '/examPaper/edit',
              query: query
            })
          }
        } else {
          return false
        }
      })
    },
    getSjkInfo (sjid) {
      const params = { sjid: sjid }
      info(params).then(res => {
        this.$http.callback(res, () => {
          const ksySjk = res.data.ksySjk
          const ksySjfl = res.data.ksySjfl
          this.flObj = { flbh: ksySjfl.flbh, flmc: ksySjfl.flmc }
          // 属性复制
          for (const key in this.sjk) {
            this.sjk[key] = ksySjk[key]
          }
          this.sjk.sjid = ksySjk.sjid
          this.oldZjfs = this.sjk.zjfs
        })
      })
    },
    showFlDialog () {
      this.showSjflDialog = true
      if (this.$refs.sjflTreeEdit !== undefined) {
        this.$refs.sjflTreeEdit.init()
      }
    },
    reloadSjfl () {
      setTimeout(() => {
        this.$refs.sjflTree.init()
      }, 200)
    }
  },
  created () {
    const sjid = this.$route.query.sjid
    this.ksid_init = this.$route.query.ksid
    if (sjid) {
      this.getSjkInfo(sjid)
    }
  }
}
</script>
<style scoped>
  #sjfltree >>> * {
    font-weight: normal !important;
  }
  .formItem{
    margin-left: 10px
  }
</style>
